import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2017 - 2018 Ab Initio
 *       UNPUBLISHED -- ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { PopupRegistryImpl } from "abreact/incubator/ui/utils/PopupRegistryImpl";
import { AbWebServices } from "abweb/service/AbWebServices";
import { DestroyListenerMgr } from "abweb/service/destroyListener/DestroyListenerMgr";
import * as React from "react";

// Reserve the right to change these to void in future (tsx previously/currently has issues w/void)

/**
 * Placeholder Base Class that all Ab Initio React components should extend.
 */
export class BaseRCmp extends React.Component {
  constructor(props, context) {
    super(props, context);
    /**
     * In general this class should be very small.  React strongly discourages inheritance,
     * and React supports Higher Order Components and Mixins to support adding functionality that would
     * typically be added via inheritance.  As such, this class is considered 'locked' -
     * if you'd like to add a method that is generally useful for all Ab Initio React components,
     * please contact Brad to discuss (we expect to have a more formal review process at some point).
     */
    // private static readonly BASERCMP_LOGGER: ILogger = LogUtils.getLogger(__filename);
    /**
     * Convenience shorthand function to support typing 'this.i18n(rbKey, msgKey, ...)'
     * instead of this.i18nService.getMessage(rbKey, msgKey, ...).
     * @deprecated Use generated strongly typed static methods in <$LibName>Resources.<msgKeyMethodName>(...),
     * such as AbWebResources.apply_next() instead of this.i18n("abweb", "apply.next")
     */
    _defineProperty(this, "i18n", void 0);
    _defineProperty(this, "destroyListenerMgr", new DestroyListenerMgr());
    // Popup registry is backed by destroy listeners,
    // and destroyListeners are torn down in reverse registration order on unmount
    _defineProperty(this, "_popupRegistry", new PopupRegistryImpl(this.destroyListenerMgr));
    const i18NService = AbWebServices.i18n;
    this.i18n = i18NService.getMessage.bind(i18NService);
  }
  get popupRegistry() {
    return this._popupRegistry;
  }

  /**
   * @ignore This should be protected as it is intended for internal use.
   */
  registerDestroyListener(listener) {
    return this.destroyListenerMgr.registerDestroyListener(listener);
  }

  /**
   * @ignore This should be protected as it is intended for internal use.
   */
  registerAsyncDestroyListener(listener) {
    return this.destroyListenerMgr.registerAsyncDestroyListener(listener);
  }

  /**
   * @ignore This should be protected as it is intended for internal use.
   */
  removeAsyncDestroyListener(listener) {
    this.destroyListenerMgr.removeAsyncDestroyListener(listener);
  }
  componentWillUnmount() {
    // Unfortunately react componentWillUnmount lifecycle method is synchronous (and react is the caller)
    // However, destroy will be guaranteed to invoke the async destroyListeners in the correct order without race conditions.
    // See CAT-1293
    this.destroy();
  }

  /**
   * Cleans up the component, including calling all registered cleanup functions. Called from
   * <code>{@link componentWillUnmount()}</code>
   */
  destroy() {
    return this.destroyListenerMgr.destroyAll();
  }
}
//# sourceMappingURL=BaseRCmp.js.map
